import { render, staticRenderFns } from "./SpecialPackageWidget.vue?vue&type=template&id=2184d0ec&scoped=true&"
import script from "./SpecialPackageWidget.vue?vue&type=script&lang=ts&"
export * from "./SpecialPackageWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184d0ec",
  null
  
)

export default component.exports